import { render, staticRenderFns } from "./PaymentRemove.vue?vue&type=template&id=6a4e36df&"
import script from "./PaymentRemove.vue?vue&type=script&lang=js&"
export * from "./PaymentRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a4e36df')) {
      api.createRecord('6a4e36df', component.options)
    } else {
      api.reload('6a4e36df', component.options)
    }
    module.hot.accept("./PaymentRemove.vue?vue&type=template&id=6a4e36df&", function () {
      api.rerender('6a4e36df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ShopSetting/Pages/Payment/components/PaymentGateway/PaymentRemove.vue"
export default component.exports